import { render } from "./SkippedOffer.vue?vue&type=template&id=778e73c4&scoped=true"
import script from "./SkippedOffer.vue?vue&type=script&lang=js"
export * from "./SkippedOffer.vue?vue&type=script&lang=js"

import "./SkippedOffer.vue?vue&type=style&index=0&id=778e73c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-778e73c4"

export default script